export const SET_OPEN_DOWNLOAD = 'SET_OPEN_DOWNLOAD';
export const SET_REPORT_BY_DATE = 'SET_REPORT_BY_DATE';
export const CLEAR_REPORT = 'CLEAR_REPORT';
